import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'basicHtml' })
export class BasicHtmlPipe implements PipeTransform {
  transform(value: string): string {
    return value.split('\n').join('<br/>');
  }
}
